import { Component, OnInit } from '@angular/core';
import { MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { Store, select } from '@ngrx/store';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LocationModel } from '@kanzi-apes/kanzi-models';
import * as fromLocations from '../../reducers';
import * as Locations from '../../actions';
import { BreadcrumbService } from '@kanzi-apes/kanzi-ui';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-edit',
    templateUrl: './location-edit.component.html',
    styleUrls: ['./location-edit.component.scss'],
    standalone: false
})
export class LocationEditComponent implements OnInit {
  breadcrumbMenu: MenuItem[] = [];
  Location$: Observable<LocationModel | null> = this.store.pipe(
    select(fromLocations.getLocation)
  );
  constructor(
    private router: ActivatedRoute,
    private store: Store<fromLocations.State>,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    this.breadcrumbService.setItems([
      {
        label: 'Editar locación',
        icon: 'fa-pen',
      },
    ]);
    
    this.router.paramMap
      .pipe(map((params: ParamMap) => Number(params.get('id'))))
      .subscribe((id) => this.store.dispatch(new Locations.LoadLocation(id)));
  }
}
